import React from 'react';
import { AlertTriangle, Info, Bot, Globe } from 'lucide-react';
import { Link } from 'react-router-dom';

export function BlogDisclaimer() {
  return (
    <div className="bg-amber-50 border-l-4 border-amber-400 p-6 rounded-lg mb-8">
      <div className="flex items-start">
        <AlertTriangle className="h-6 w-6 text-amber-600 mt-1 mr-3 flex-shrink-0" />
        <div className="space-y-4">
          <div>
            <h3 className="text-lg font-semibold text-amber-800 mb-2">Important Disclaimer</h3>
            <p className="text-amber-700 leading-relaxed">
              The information provided on this blog is for <strong>general informational purposes only</strong> and 
              does not constitute financial, investment, or trading advice of any kind. Nothing on this platform 
              should be construed as professional financial advice.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-4 text-sm">
            <div className="flex items-start gap-2">
              <Globe className="h-4 w-4 text-amber-600 mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-medium text-amber-800">Public Domain Information</p>
                <p className="text-amber-700">
                  Exchange rates and market data are sourced from publicly available information 
                  and third-party APIs. We do not guarantee accuracy or completeness.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-2">
              <Bot className="h-4 w-4 text-amber-600 mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-medium text-amber-800">AI-Generated Content</p>
                <p className="text-amber-700">
                  Some content is generated using artificial intelligence and should be 
                  independently verified before making any financial decisions.
                </p>
              </div>
            </div>
          </div>

          <div className="pt-2 border-t border-amber-200">
            <p className="text-amber-700 text-sm">
              <strong>Always consult with qualified financial professionals</strong> before making investment 
              or trading decisions. Read our full{' '}
              <Link to="/disclaimer" className="underline hover:text-amber-800 font-medium">
                disclaimer
              </Link>{' '}
              for complete terms and conditions.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}